import { Injectable } from '@angular/core';
import { ApiFaqService, GetFaqResult } from '@timechef/core/api';
import { AuthRepository } from '@timechef/core/auth';
import { CouldBeCached, IN_CACHE, IN_CACHE_SOURCE } from '@timechef/core/utils/elf-utils';
import { tap } from 'rxjs';

import { FaqRepository } from './faq.repository';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  constructor(
    private faqRepo: FaqRepository,
    private authRepo: AuthRepository,
    private faqApi: ApiFaqService,
  ) {}

  getFaqQuestions() {
    const isLoggedIn = this.authRepo.getIsLoggedIn();

    return this.faqApi.getFaq({ SiteName: isLoggedIn ? this.authRepo.getCurrentSiteName() : undefined }).pipe(
      this.faqRepo.faqAuthenticationDS.trackRequestStatus(),
      this.faqRepo.faqAuthenticationDS.skipWhileCached(IN_CACHE_SOURCE),
      tap((data: CouldBeCached<GetFaqResult>) => {
        if (data === IN_CACHE) {
          return;
        }

        this.faqRepo.updateFaqQuestions(data.categories);
      }),
    );
  }
}
